module.exports = __webpack_public_path__ + "static/img/exploit7.c46b32ee.png";